import React, { useState, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import '../../../../pages/customer/customer.css';
import { Context } from '../../../../services/context';
import Button from 'react-bootstrap/Button';

export default function OpenModal(props) {
  const context = useContext(Context);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    context.setAttachments(false);
  };
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="success" onClick={handleShow}>
        {props.buttonLabel}
      </Button>

      <Modal
        show={show}
        size={props.modalSize}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.titleLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.content}</Modal.Body>
      </Modal>
    </>
  );
}
